module.exports = __webpack_public_path__ + "static/media/SandBalls1.24a29e5a.jpg";